// extracted by mini-css-extract-plugin
export default {"container":"NoteSlat__container--JTF74HQOhT"};